export function logAppVersion(appName: string, tag: string): void {
  console.log(
    `%c ${appName} %c ${tag} `,
    'background:#8F97D9; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
    'background:#fff; padding: 1px; border-radius: 0 3px 3px 0;  color: #8F97D9; border: 1px solid #8F97D9'
  )
}
